<template>
  <!--Start Card Item-->
  <div>
    <v-row v-if="Array.isArray(items) && items.length" class="mt-1">
      <v-col cols="12" v-for="item in items" :key="item.id" class="py-4">
        <v-card outlined elevation="0" class="product_card">
          <v-card-text class="pa-0 ma-0">
            <v-list-item three-line>
              <v-list-item-content class="align-start">
                <v-list-item-title class="font-weight-bold text-lg-h6 product_name--text">
                  {{ item.name }}
                </v-list-item-title>

                <v-list-item-subtitle
                  v-if="item.description"
                  class="item_description my-3 product_description--text"
                >
                  <span
                    style="font-size: 10pt !important;"
                    v-html="item.description"
                  ></span>
                </v-list-item-subtitle>

                <v-list-item-subtitle
                  class="font-weight-bold primary--text"
                  style="font-size: 12pt !important;"
                >
                  {{
                    item.sellingPrice && item.sellingPrice.toFixed(2) | currency
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="100">
                <v-img
                  v-if="item.image"
                  :src="item.image"
                  :alt="item.name"
                  contain
                />
                <v-img
                  v-else
                  src="@/assets/images/box.png"
                  :alt="item.name"
                  contain
                />
              </v-list-item-avatar>
            </v-list-item>
          </v-card-text>

          <v-card-actions
            class="pt-7 px-4"
            style="border-top: 1px lightgray solid;"
          >
            <v-row>
              <v-col cols="6" class="pb-0">
                <v-text-field
                  height="40px"
                  :value="quantity(item.id)"
                  readonly
                  dense
                  class="centered-input"
                  outlined
                >
                  <template v-slot:prepend-inner>
                    <v-icon @click="minus(item.id)">mdi-minus</v-icon>
                  </template>

                  <template v-slot:append>
                    <v-icon
                      @click="yourPlat(item.id, item.name, item.description)"
                    >
                      mdi-plus
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <v-col cols="6" class="pb-0">
                <v-btn
                  class="mx-auto"
                  height="40px"
                  elevation="0"
                  block
                  color="accent"
                  :disabled="quantity(item.id) > 0"
                  @click="yourPlat(item.id, item.name, item.description)"
                >
                  <v-icon v-if="quantity(item.id) > 0">mdi-check</v-icon>
                  <span v-else>{{ $t("generic.lang_add_to_plat") }}</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-sheet
      v-else
      elevation="0"
      outlined
      height="200"
      class="mt-4 d-flex justify-center align-center"
    >
      <p>
        {{ $t("generic.lang_no_items_available_in_selected_category") }}
      </p>
    </v-sheet>
  </div>
  <!--End Card Item-->
</template>

<script>
/*import plugins*/
import { createNamespacedHelpers } from "vuex";

export default {
  name: "ItemCard",

  data() {
    return {
      count: 1,
    };
  },

  computed: {
    ...createNamespacedHelpers("items").mapGetters(["quantity", "items"]),
  },

  methods: {
    ...createNamespacedHelpers("items").mapMutations(["minus"]),

    //add selected items
    yourPlat(itemId, itemName, itemDescription) {
      let selectedItem = {
        itemId: itemId,
        itemName: itemName,
        itemDescription: itemDescription,
      };
      this.$store.commit("items/addSelectedItems", selectedItem);
    },
  },
};
</script>

<style scoped>
.centered-input {
  width: 130px !important;
}

.centered-input >>> input {
  text-align: center;
}

.item_description {
  display: block !important;
}
</style>
